import { createAction } from '@reduxjs/toolkit';
export const SAVE_NOTIFICATIONS= 'SAVE_NOTIFICATIONS';
export const saveNotificationsAction = createAction(SAVE_NOTIFICATIONS);